import React from 'react'
import { Link} from 'react-router-dom'
import MobileSidebar from './../../../widgets/MobileSidebar'

import {
    Button,
    NavContainer
} from './HeaderWidgetComponent.style';

  
  function HeaderWidgetComponentTransaparent() {
    return (
      <div className="">
          <nav className=" z-depth-0 transparent hide-on-med-and-down" style={{height:"120px"}}>
                <NavContainer className="" style={{
                }}>
                <Button to="/" className="brand-logo">
                    <img style={{
                        marginTop:"10px"    
                    }} src="https://res.cloudinary.com/yalla-ng/image/upload/v1657118226/re-brand/yalla_logo_2_wa7dlm.svg" width="160px"  alt="" />    
                </Button>
                <Link to="/"  className="sidenav-trigger pt-25">
                    <MobileSidebar/>
                </Link>
                <ul className="right  hide-on-med-and-down mt-25 ">
                    <li>
                        <Button to='/' className='white-text'>
                            Home
                        </Button>
                    </li>
                    <li>
                        <Button to='/about' className='white-text'>
                            About Us
                        </Button>
                    </li>
                    <li>
                        <Button to='/faqs' className='white-text'>
                            FAQs
                        </Button>
                    </li>
                    <li>
                        <Button to='/blog' className='white-text'>
                            Blog
                        </Button>
                    </li>
                    <li>
                        <Button to="/" className="btn-flat transparent btn-large white-text" style={{
                            border: "2px solid #00A568",
                            borderRadius:"8px"

                        }}>
                           Create Account
                        </Button>
                    </li>
                            
                </ul>
                </NavContainer>
            </nav>

            <nav className="z-depth-0 white hide-on-large-only show-on-medium show-on-small" style={{height:"85px"}}>
                <NavContainer className=" " style={{
                    // border:"2px dashed red"
                }}>
                <Link to="#!" className="brand-logo">
                    <img style={{
                        marginTop:"-10px"    
                    }} src="https://res.cloudinary.com/acekn/image/upload/v1617275602/yalla/logo_vxor6i.png" height="150px"  alt="" />    
                </Link>
                <Link to="#"  className="sidenav-trigger pt-25">
                    <MobileSidebar/>
                </Link>
                <ul className="right  hide-on-med-and-down mt-25 ">
                    <li>
                        <Button to='/'>
                            Home
                        </Button>
                    </li>
                    <li>
                        <Button to='/about'>
                            About
                        </Button>
                    </li>
                    <li>
                        <Button to='/'>
                            How it works
                        </Button>
                    </li>
                    <li>
                        <Button to='/faqs'>
                            FAQs
                        </Button>
                    </li>
                    <li>
                        <Button to="/" className="btn-flat   transparent btn-large " style={{
                            border: "2px solid #00A568",
                            borderRadius:"8px"

                        }}>
                           Get in touch
                        </Button>
                    </li>
                           
                            
                </ul>
                </NavContainer>
            </nav>

                        
      </div>
    )
  }
  
  export default HeaderWidgetComponentTransaparent